import { QuestionPlanSaleStartBeforeDate } from "@/components/features/items/edit/plan/_shared/ui/components/term/sale-start-before-date";

import { useDayTripPlanSaleStartBeforeDate } from "./hooks";

export const QuestionDayTripPlanSaleStartBeforeDate = () => {
	const { saleStartBeforeDate, onSetSaleStartBeforeDate } = useDayTripPlanSaleStartBeforeDate();

	return (
		<QuestionPlanSaleStartBeforeDate
			saleStartBeforeDate={saleStartBeforeDate}
			onSetSaleStartBeforeDate={onSetSaleStartBeforeDate}
		/>
	);
};

QuestionPlanSaleStartBeforeDate.displayName = "QuestionPlanSaleStartBeforeDate";
